import {graphql, useStaticQuery} from "gatsby";
import {useI18next} from "gatsby-plugin-react-i18next";

export const flatListToHierarchical = (
  data = [],
  {idKey='id',parentKey='parentId',childrenKey='children'} = {}
) => {
  const tree = [];
  const childrenOf = {};
  data.forEach((item) => {
    const newItem = {...item};
    const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
    childrenOf[id] = childrenOf[id] || [];
    newItem[childrenKey] = childrenOf[id];
    parentId
      ? (
        childrenOf[parentId] = childrenOf[parentId] || []
      ).push(newItem)
      : tree.push(newItem);
  });
  return tree;
};

export const useMenuItems = (location) => {

  const { menus } = useStaticQuery(graphql`
    query {
      menus : allWpMenu {
        nodes {
          name
          slug
          locations
          menuItems {
            nodes {
              cssClasses
              url
              target
              parentId
              id
              label
            }
          }
        }
      }
    }
  `)
  
  const { language, defaultLanguage} = useI18next();

  location = language !== defaultLanguage ? location + `___${language.toUpperCase()}` : location;

  let menu = menus.nodes.find( item => item.locations.includes(location)) || [];
  if(menu.menuItems && menu.menuItems.nodes)
    menu = flatListToHierarchical(menu.menuItems.nodes);

  return menu;
};
